import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';import { AgGridModule } from 'ag-grid-angular';
import { provideGlobalGridOptions } from 'ag-grid-community';
import { LicenseManager} from 'ag-grid-enterprise';

LicenseManager.setLicenseKey(environment.AG_GRID_CONFIG);

provideGlobalGridOptions({
  theme: 'legacy',
});

if (environment.production) {
  enableProdMode();
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule) // NOSONAR
  .catch(err => console.info(err)); // NOSONAR
